"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require(".");
var _components = require("../../../../swcp-base/js/components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ImprintAndLegal = () => {
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      flexFlow: "column",
      height: "100%"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container-fluid justify-content-left mt-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-narrow"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex mb-4"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "page-title ml-0"
  }, "Imprint - Privacy Policy - Legal")), /*#__PURE__*/_react.default.createElement("div", {
    className: "card rounded shadow mb-3 p-5"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Table of contents"), /*#__PURE__*/_react.default.createElement("div", {
    className: "row mt-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "#imprint"
  }, "Imprint")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "#privacy"
  }, "Privacy Policy")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "#terms"
  }, "Terms of Use")))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "card rounded shadow mb-3 p-5",
    id: "imprint"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Imprint"), /*#__PURE__*/_react.default.createElement("div", {
    className: "row mt-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement(_.ImprintText, null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "card rounded shadow mb-3 p-5",
    id: "privacy"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Privacy Policy"), /*#__PURE__*/_react.default.createElement("div", {
    className: "row mt-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement(_.PrivacyText, null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "card rounded shadow mb-3 p-5",
    id: "terms"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Terms of Use"), /*#__PURE__*/_react.default.createElement("div", {
    className: "row mt-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement(_.TermsOfUse, null)))))), /*#__PURE__*/_react.default.createElement(_components.ImprintLink, null));
};
var _default = exports.default = ImprintAndLegal;
module.exports = exports.default;